const API_BASE = process.env.REACT_APP_API_BASE;

export async function fetchAllUsers(idToken) {
  const r = await fetch(`${API_BASE}/admin/users`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  const data = await r.json();
  if (!r.ok) throw new Error(data.error || "Failed to fetch users");
  return data.users;
}

export async function fetchUserSubmissions(sub, idToken) {
  const r = await fetch(`${API_BASE}/admin/users/${sub}/submissions`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  const data = await r.json();
  if (!r.ok) throw new Error(data.error || "Failed to fetch submissions");
  return data.submissions || [];
}
